export const navlinks = [
  {
    title: 'Fitur',
    path: '#fitur',
    type: 'sub',
  },
  {
    title: 'Cara Kerja',
    path: '#carakerja',
    type: 'sub',
  },
  {
    title: 'Manfaat',
    path: '#manfaat',
    type: 'sub',
  },
  {
    title: 'Tim',
    path: '#tim',
    type: 'sub',
  },
  {
    title: 'Ngamen Bizz',
    path: '/ngamenbizz/',
    type: 'sub',
    link: true,
  },
];
